export default {
  ja:[
    "アカウント状況",
    "アイテムの購入",
    "アイテムの販売",
    "アイテムをリクエスト",
    "リクエストに応える",
    "有効な残高",
    "有効反映待ちの残高",
    "円",
    "1200円以上じゃないと自分の口座に出金できません",
    "出金する",
    "プロフィール",

    "これらの個人情報は配送時以外にサービスでは利用しませんが、stirpe決済をする上で必須になります",
    "住所等の情報",
    "必須データ入力済み",
    "出金先口座情報",
    "本人確認書類",
    "ログアウト",
    "メールアドレス",
    "サービス内言語",
    "住んでる国",
    "リクエスト数",

    "提案したアイデア数",
    "最近のリクエスト",
    "最近のアイデア",
    "値段",
    "状態",
    "新品",
    "中古",
    "いくら出金しますか？",
    "※ 1回の出金には250 + 0.25% 円の手数料がかかります。",
    "詳しくは",

    "こちら",
    "をご覧ください",
    "Stripe手数料を差し引いた最大値",
    "いくら出金しますか？(例:1000)",
    "本当にペイアウトしますか？",
    "金額",
    "手数料",
    "全額",
    "ペイアウト成功！",
    "振込予定日は",

    "４日経つと残高が有効になり、毎週月曜日に口座に自動入金されます。",
    "更新",
    "閉じる",
  ],
  en: [
    "Account Status",
    "Purchase otaku item",
    "Sell the otaku item",
    "Request order",
    "Respond to request ",
    "Available Balance",
    "Pending Balance",
    "JPY",
    "You cannot withdraw money unless the effective balance is 1,200 yen or more",
    "Payout",
    "Your profile",

    "(This personal information will not be disclosed, but it will be required for stirpe payment)",
    "Address information",
    "data inputted",
    "Bank information",
    "Identity verification",
    "logout",
    "Email address",
    "language",
    "Current country",
    "Number of requests",

    "Suggest an idea",
    "Recent requests",
    "Recent ideas",
    "Price",
    "State",
    "New",
    "Used",
    "How much do you want to pay out?",
    "※There is a 250 + 0.25% jpy fee for each payout.",
    "For more information",

    "Please check here",
    "",
    "Maximum value substracted from Stripe fees",
    "How much will you withdraw??(ex:1000)",
    "Do you really want to pay out？",
    "Price",
    "Fee",
    "Total",
    "payout is succeffly!",
    "arrival date is",

    "After 4 days, your balance will be activated and your account will be automatically credited every Monday.",
    "update",
    "cancel",
  ]
}
